import '~/assets/scss/about.scss'

import getSwiperSlider from '~/js/modules/slider';
import '~/js/modules/switches';
import Form from '~/js/modules/form';
import '~/js/modules/tabs';

window.addEventListener(`DOMContentLoaded`, () => {
  const bannersSlider = document.querySelector(`.banners__slider`);
  const sliderA = document.querySelector(`.slider-a`);
  const accordions = document.querySelectorAll(`.accordion`);
  const forms = document.querySelectorAll(`.form-b__form`);
  const stock = document.querySelector(`.js-stocks-slider`);

  if (forms.length) {
    forms.forEach((form) => new Form(form));
  }

  const interleaveOffset = 0.5;
  if (bannersSlider.length) {
    const bannersSwiperParams = {
      speed: 1000,
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 3,
      watchSlidesProgress: true,
      autoplay: {
        delay: 9000,
        waitForTransition: false,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: `.banners .slider-arrows__arrow--next`,
        prevEl: `.banners .slider-arrows__arrow--prev`,
      },
      pagination: {
        el: `.slider-dots`,
        clickable: true,
        bulletClass: `slider-dots__dot`,
        bulletActiveClass: `active`,
        renderBullet(index, className) {
          return `
          <button class="${className}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="25"></circle>
            </svg>
          </button>`;
        },
      },
      on: {
        progress() {
          for (let i = 0; i < this.slides.length; i++) {
            const slideProgress = this.slides[i].progress;
            const innerOffset = this.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            this.slides[i].querySelector(`.slider-top__image`).style.transform = `translate3d(` + innerTranslate + `px, 0, 0)`;
          }
        },
        touchStart() {
          this.autoplay.stop();
          for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transition = ``;
          }
        },
        touchEnd() {
          this.autoplay.start();
        },
        slideChange() {
          const currentIndex = this.realIndex < 10
            ? `0${this.realIndex + 1}`
            : `${this.realIndex + 1}`;
          this.el.querySelector(`.slider-pages__page--current`).textContent = currentIndex;
        },
        setTransition(speed) {
          for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transition = speed + `ms`;
            this.slides[i].querySelector(`.slider-top__image`).style.transition = speed + `ms`;
          }
        },
      },
    }
  };

  const sliderASwiperParams = {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: `.slider-a .slider-arrows__arrow--next`,
      prevEl: `.slider-a .slider-arrows__arrow--prev`,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    }
  };

  const stockSwiperParams = {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: `.slider-arrows .js-stocks-next`,
      prevEl: `.slider-arrows .js-stocks-prev`,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
  };

  const aboutObjectsSlider = document.querySelector(`.js-about-slider-cards`);

  const aboutObjectsSwiperParams = {
    slidesPerView: `1.25`,
    spaceBetween: 25,
    loop: false,
    slidesOffsetAfter: 45,
    autoplay: false,
    navigation: {
      nextEl: `.about-rating-cards .slider-arrows__arrow--next`,
      prevEl: `.about-rating-cards .slider-arrows__arrow--prev`,
      disabledClass: `disabled`,
    },
    pagination: false,
    breakpoints: {
      1024: {
        slidesPerView: `3`,
        slidesOffsetAfter: 0,
      }
    }
  };

  if (aboutObjectsSlider) {
    getSwiperSlider(aboutObjectsSlider, aboutObjectsSwiperParams);
  }

  if (sliderA) {
    getSwiperSlider(sliderA, sliderASwiperParams);
  }
  if (stock) {
    getSwiperSlider(stock, stockSwiperParams);
  }

  if (bannersSlider.length) {
    getSwiperSlider(bannersSlider, bannersSwiperParams);
  }

  const mobileHiddenCards = document.querySelectorAll('.js-mobile-hidden');
  if (mobileHiddenCards) {
    const mobileRollUp = document.querySelector('.js-mobile-roll-up')
    if (mobileRollUp) {
      mobileRollUp.addEventListener('click', function () {

        mobileHiddenCards.forEach((card) => {
          card.classList.toggle('mobile-roll-up');
        })
        mobileRollUp.classList.toggle('active');
      })
    }
  }
});
